export const ONLINE_TAB_STATUS_DISABLED = 1;
export const ONLINE_TAB_STATUS_ACTIVE = 2;

export const ONLINE_PING_INTERVAL = 10;
